import { Button, Form, Input, message, Select } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Attachments from './Attachments'
import CommentList from './comment/CommentList'

import {
    createSelectOptions,
    isValidArray,
    isValidObject,
} from '../../../../../../sprints/components/testReport/testCases/forms/helper'
import { testCaseCommentList } from '../../../../../redux/testCaseComment/testCaseComment.slice'
import {
    apiAddResult,
    getAttachmentPreUrl,
    uploadAttachmentToAWS,
} from '../../../../../redux/testRun/testRun.service'
import {
    testRunState,
    testRunTestCaseDetail,
    toggleReportDetails,
} from '../../../../../redux/testRun/testRunList.slice'
import SkeletonResultForm from './SkeletonResultForm'

const { TextArea } = Input

function ResultForm(props) {
    const {
        stateTestRun = false,
        setStateTestRun = () => {},
        handleTestCaseList = () => {},
        setSelectedRowKeys = () => {},
        reportId = '',
    } = props

    const dispatch = useDispatch()
    const [form] = Form.useForm()

    const {
        testRunTestCaseDetailLoading = false,
        testRunTestCaseDetail: testCaseDetailData = {},
        fetchReportToggle,
    } = useSelector(testRunState)

    const [fileList, setFileList] = useState([])
    const [saveLoading, setSaveLoading] = useState(false)

    const isSingleEdit = stateTestRun?.editType === 'single' ? true : false
    const activeId = stateTestRun?.selectedTCID || ''

    const generateImageUrl = async (file) => {
        const { name = '', type = '' } = file ?? {}
        const formData = {
            data: [
                {
                    filename: name,
                    contentType: type || 'document',
                },
            ],
        }

        const result = await getAttachmentPreUrl(formData)

        const { success = false, data = {} } = result?.data || {}

        if (success) {
            const uploadURL = data?.[0]?.uploadUrl ?? ''
            const publicLink = data?.[0]?.publicLink ?? ''
            const response = await uploadAttachmentToAWS(file, uploadURL)

            if (response?.ok) {
                return publicLink
            }
            return ''
        }

        return ''
    }

    const handleSubmit = async (values) => {
        setSaveLoading(true)
        let imageUrls = []
        if (fileList.length !== 0) {
            // Step 2: Upload files one by one or in parallel
            const uploadedUrls = await Promise.all(
                fileList.map(async (file) => {
                    console.log('Log ==>file', file)
                    const fileName = file?.name || ''
                    try {
                        const url = await generateImageUrl(file?.originFileObj)
                        return { url: url, fileName: fileName } // or any response from AWS
                    } catch (error) {
                        setSaveLoading(false)
                        return null
                    }
                })
            )

            imageUrls = [...imageUrls, ...uploadedUrls.filter(Boolean)]
        }

        const finalUrls = isValidArray(imageUrls)
            ? imageUrls?.map((item) => {
                  return {
                      url: item?.url || '',
                      fileName: item?.fileName || '',
                  }
              })
            : []

        const formData = {
            id: reportId,
            data: {
                testCaseIds: stateTestRun?.selectedTCID || [],
                status: isValidObject(values?.status)
                    ? values?.status?.value
                    : values?.status,
                ...(values?.comment || isValidArray(finalUrls)
                    ? {
                          comment: {
                              ...(values?.comment
                                  ? {
                                        description: values.comment || '',
                                    }
                                  : {}),
                              ...(isValidArray(finalUrls)
                                  ? {
                                        attachments: finalUrls,
                                    }
                                  : {}),
                          },
                      }
                    : {}),
                // images: imageUrls,
            },
        }

        const resp = await apiAddResult(formData)

        if (resp?.data?.success) {
            message.success(
                resp?.data?.message || 'Test case submitted successfully!'
            )
            // if (!isSingleEdit) {

            // }
            setStateTestRun({
                ...stateTestRun,
                drawerEdit: false,
            })
            //Call report details API
            dispatch(toggleReportDetails(!fetchReportToggle))
            setFileList([])
            setSelectedRowKeys([])
            handleTestCaseList()
            // handleCommentList()
            form.resetFields()
        } else {
            message.error(resp?.data?.message || 'Something went wrong!')
        }
        setSaveLoading(false)
    }

    const STATUS_OPTIONS = ['Pending', 'Pass', 'Fail', 'Retest']

    const handleTestCaseDetails = () => {
        const payload = {
            reportId: reportId,
            testCaseId: stateTestRun?.selectedTCID?.[0] || '',
        }
        dispatch(testRunTestCaseDetail(payload)).then((resp) => {
            if (isValidObject(resp?.payload?.data)) {
                const detailsData = resp?.payload?.data || {}

                form.setFieldsValue({
                    status: createSelectOptions(detailsData?.status),
                })
            }
        })
    }

    useEffect(() => {
        if (stateTestRun.drawerEdit && isSingleEdit) {
            // handleCommentList()
            handleTestCaseDetails()
            setFileList([])
        }
    }, [stateTestRun.drawerEdit])

    return (
        <div
            style={{
                maxWidth: 700,
                margin: '0 auto',
                paddingLeft: '20px',
                paddingRight: '20px',
                paddingTop: '20px',
                background: '#fff',
                borderRadius: '8px',
            }}
        >
            {testRunTestCaseDetailLoading && <SkeletonResultForm />}
            {/* <SkeletonTestCaseForm /> */}
            {!testRunTestCaseDetailLoading && (
                <Form
                    requiredMark={false}
                    form={form}
                    layout="horizontal"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    labelAlign="left"
                    onFinish={handleSubmit}
                    initialValues={{
                        comment: '',
                        status: {
                            label: 'Pending',
                            value: 'Pending',
                        },
                        images: [],
                    }}
                >
                    <Form.Item
                        label={
                            <span>
                                Status <span style={{ color: 'red' }}>*</span>
                            </span>
                        }
                        name="status"
                        rules={[
                            {
                                required: true,
                                message: 'Please select a Status',
                            },
                        ]}
                        style={{ marginBottom: 16 }}
                    >
                        <Select
                            placeholder="Select Status"
                            options={STATUS_OPTIONS.map((s) => ({
                                value: s,
                                label: s,
                            }))}
                        />
                    </Form.Item>

                    {/* Description */}
                    <Form.Item
                        label="Comment"
                        name="comment"
                        style={{ marginBottom: 16 }}
                    >
                        <TextArea rows={4} placeholder="Enter comment" />
                    </Form.Item>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                        }}
                    >
                        <div style={{ width: '25%' }}>Attachments :</div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: '',
                                maxWidth: '75%',
                            }}
                            className=""
                        >
                            <Attachments
                                fileList={fileList}
                                setFileList={setFileList}
                            />
                        </div>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'end',
                            width: '100%',
                            gap: '10px',
                            marginTop: '20px',
                        }}
                    >
                        <Button
                            type="default"
                            htmlType="submit"
                            loading={saveLoading}
                        >
                            Save
                        </Button>

                        <Button
                            type="default"
                            htmlType="button"
                            onClick={() => {
                                setStateTestRun((prev) => ({
                                    ...prev,
                                    drawerEdit: false,
                                }))
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </Form>
            )}
            {isSingleEdit && (
                <div style={{ marginTop: 15 }}>
                    <CommentList />
                </div>
            )}
        </div>
    )
}

export default ResultForm
